













































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import {
  ConversationDto,
  DeleteConversationCommand,
  CommunicationParty,
  UpdateReadStatusCommand,
  MessageType,
  MessageDto,
  IMLabel
} from "../../../types/interface/IM/IMTypes";
import { toLocalTime } from "@/api/net/util";
import Badge from "@/components/Badge.vue";
import { deleteConversation, changeMessageReadStatus } from "@/api/net/im";
import store from "@/store/index";
import { uncodeUtf16 } from "@/api/net/util.ts";
import { Getter } from "vuex-class";
import { addLabel, deleteLabel } from "@/api/net/im";
import { generateGUID } from "../../../api/net/util";

@Component({
  name: "conversation-row",
  components: {
    Badge
  }
})
export default class ConversationRow extends Vue {
  @Prop({ default: null }) item: ConversationDto;
  @Prop() onConversationDeleted: () => void;
  @Getter("isPc") isPc!: boolean;

  public get lastMessageContent(): string {
    const lastMessage: MessageDto = this.item.lastMessage;
    const imType: number = this.item.lastMessage.type;
    if (imType === MessageType.Text) {
      return uncodeUtf16(lastMessage.content ? lastMessage.content : "");
    } else {
      return "[Photo]";
    }
  }

  lastSentTime: string | null = this.item
    ? toLocalTime(this.item.lastMessage.sendTime)
    : null;

  showButton: boolean = false;
  onConversationSelected(item: ConversationDto): void {
    this.$router.push({
      name: "Conversation",
      query: {
        toUserId: item.contactsId,
        orderId: item.orderId,
        merchId: item.merchId,
        userOrderScores: JSON.stringify(this.userOrderScores)
      } as any
    });
  }

  async markMessagesAsRead(orderId: string, userId: string) {
    const request: UpdateReadStatusCommand = {
      orderId,
      userId,
      commandFrom: CommunicationParty.merchant,
      merchId: null
    };
    await changeMessageReadStatus(request);
  }

  async onDelete(e: MouseEvent, conversation: ConversationDto) {
    e.stopPropagation();
    let id: string = conversation.id;
    /*
     * 有orderId的message, id长度为64
     * 没有orderId的message, id长度为32
     */

    if (id.length < 64) {
      const cmd: DeleteConversationCommand = {
        targetUserId: conversation.contactsId,
        commandFrom: CommunicationParty.merchant,
        merchId: null
      };
      await this.markMessagesAsRead(
        conversation.orderId ? conversation.orderId : "",
        conversation.contactsId
      );
      await deleteConversation(cmd);
      this.onConversationDeleted();
    } else {
      const cmd: DeleteConversationCommand = {
        targetUserId: conversation.contactsId,
        commandFrom: CommunicationParty.merchant,
        merchId: null
      };
      await this.markMessagesAsRead(
        conversation.orderId ? conversation.orderId : "",
        conversation.contactsId
      );
      await deleteConversation(cmd);
      this.onConversationDeleted();
    }
  }

  messageTime(time: string): string {
    return toLocalTime(new Date(time));
  }

  public get userOrderScores(): Array<{
    good: number;
    bad: number;
    icon: string;
  }> {
    return [
      {
        icon: "mdi-storefront",
        good: this.item.userOrderScores.positiveOrderForShop || 0,
        bad: this.item.userOrderScores.negativeOrderForShop || 0
      },
      {
        icon: "yamimeal",
        good: this.item.userOrderScores.positiveOrderForPlatform || 0,
        bad: this.item.userOrderScores.negativeOrderForPlatform || 0
      }
    ];
  }

  inputLabel: string = "";
  showLabelDialog: boolean = false;
  openLabelDialog() {
    this.showLabelDialog = true;
  }
  async handleAddLabel() {
    if (this.inputLabel) {
      try {
        const params: IMLabel = {
          id: generateGUID(),
          userId: this.item.userId,
          merchId: this.item.merchId,
          label: this.inputLabel
        };
        const { status } = await addLabel(params);
        if (status * 1 === 200) {
          this.showLabelDialog = false;
          this.$emit("updateConversationList");
          this.$message.show({
            text: "Success"
          });
        }
      } catch (e) {
        this.$message.show({
          text: "fail"
        });
        this.$store.commit("handleShowLoading", false);
      } finally {
        // this.$store.commit("handleShowLoading", false);
      }
    }
    this.inputLabel = "";
  }
  async handleDeleteLabel(id: string, labelIndex: number) {
    try {
      const { status } = await deleteLabel(id, this.item.merchId);
      if (status * 1 === 200) {
        this.labelArr.splice(labelIndex, 1);
        // this.$emit("updateConversationList"); // IM 合并完成后删除
        this.$message.show({
          text: "Success"
        });
      }
    } catch (e) {
      this.$message.show({
        text: "fail"
      });
    } finally {
      this.$store.commit("handleShowLoading", false);
    }
  }

  public get labelArr(): IMLabel[] {
    return this.item.labels;
  }
}
